module.exports = __webpack_public_path__ + "images/novice-guide-usercenter.gif";